import makeService from './api';

export default makeService('order_types');
